<template>
	<ViewFeedItem class="view-feed-venuecheckinsnearby">
		<template v-slot:header>
			<ViewLayoutModuleHeader title="Happening nearby">
				<RouterLink v-bind:to="{ name: 'PagePlaces' }">
					<strong>View All</strong>
				</RouterLink>
			</ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<ChalkyVenueList
				class="horizontal"
				v-bind:useLocation="true"
				v-bind:venueCollection="venueCollection"
				v-on:venue:select="Handle_OnSelectVenue"
			/>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import * as Factory from '@/App/Factory';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, event, mounted } from '@/Utility/Decorators';

	/**
	 * Location change + fetch is handled by the List component.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedVenueCheckinsNearby extends ViewBase {
		/**
		 * @type ChalkySticks/Collection/Venue
		 */
		@Prop({
			default: () => Factory.Venue.collection({ limit: 8 }),
		})
		public venueCollection!: ChalkySticks.Collection.Venue;

		/**
		 * @type ChalkySticks/Collection/VenueCheckin
		 */
		@Prop({
			default: () =>
				new ChalkySticks.Collection.VenueCheckin({
					limit: 8,
					qp: {
						group_by_venue: true,
					},
				}),
		})
		public venueCheckinCollection!: ChalkySticks.Collection.VenueCheckin;

		/**
		 * @return void
		 */
		@mounted
		public setup(): void {
			this.venueCheckinCollection.fetch();
		}

		/**
		 * @return void
		 */
		@mounted
		public attachEvents(): void {
			this.venueCheckinCollection.on('complete', this.Handle_OnVenueCheckinCollectionComplete);
		}

		/**
		 * @return void
		 */
		@beforeDestroy
		public detachEvents(): void {
			this.venueCheckinCollection.off('complete', this.Handle_OnVenueCheckinCollectionComplete);
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnVenueCheckinCollectionComplete(): Promise<void> {
			this.venueCollection.clear();

			this.venueCheckinCollection.each((venueCheckinModel: ChalkySticks.Model.VenueCheckin) => {
				this.venueCollection.add(venueCheckinModel.venue);
			});
		}

		/**
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectVenue(venueModel: ChalkySticks.Model.Venue): Promise<void> {
			this.$store.dispatch('gotoVenue', venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-feed-venuecheckinsnearby {
		--chalky-utility-gallery-aspect-ratio: 4 / 3;
	}
</style>
